module.exports = __webpack_public_path__ + "img/smartphone.978381e6.svg";